import gql from 'graphql-tag';

export const mutationDeleteDokkioLabel = gql`
  mutation deleteDokkioLabel (
    $id: DokkioID!
  ) {
    deleteDokkioLabel (
      id: $id
    )
  }
`;
export default mutationDeleteDokkioLabel;
